// extracted by mini-css-extract-plugin
module.exports = {"banner":"CookieBanner_banner__2wuVL","text":"CookieBanner_text__3NP9c","actions":"CookieBanner_actions__2Zuf_"};